import React, { useState } from 'react';
import { Container, Row, Col, Button } from 'react-bootstrap';
import { styles } from "../styles";

const MultiLingualDemo = () => {
    const [selectedQuestion, setSelectedQuestion] = useState(0);

    const languages = [
        {
            name: "Hindi",
            language: "hindi",
            img: "https://firebasestorage.googleapis.com/v0/b/hey-addy-chatgpt.appspot.com/o/public%2FlandingPage%2FmultilingualDemo%2Fmultilingual_hindi.gif?alt=media&token=9e523b10-aa0f-496b-b21b-11b296b1d8ac",
        },
        {
            name: "English",
            language: "english",
            img: "https://firebasestorage.googleapis.com/v0/b/hey-addy-chatgpt.appspot.com/o/public%2FlandingPage%2FmultilingualDemo%2Fmultilingual_english.gif?alt=media&token=3db03e15-1a83-43ca-9eab-fe677047d5ff",
        },
        {
            name: "Español",
            language: "spanish",
            img: "https://firebasestorage.googleapis.com/v0/b/hey-addy-chatgpt.appspot.com/o/public%2FlandingPage%2FmultilingualDemo%2Fmultilingual_spanish.gif?alt=media&token=abaaa2c7-5b30-4577-99b4-c4cda1f04681",
        },
        {
            name: "عربي",
            language: "arabic",
            img: "https://firebasestorage.googleapis.com/v0/b/hey-addy-chatgpt.appspot.com/o/public%2FlandingPage%2FmultilingualDemo%2Fmultilingual_arabic.gif?alt=media&token=7855c45e-0225-427d-9461-bef4cf133de7",
        },
        {
            name: "Français",
            language: "french",
            img: "https://firebasestorage.googleapis.com/v0/b/hey-addy-chatgpt.appspot.com/o/public%2FlandingPage%2FmultilingualDemo%2Fmultilingual_french.gif?alt=media&token=39b77c43-6db8-4a07-b109-88da1acdb70a",
        },
        {
            name: "Português",
            language: "portuguese",
            img: "https://firebasestorage.googleapis.com/v0/b/hey-addy-chatgpt.appspot.com/o/public%2FlandingPage%2FmultilingualDemo%2Fmultilingual_portuguese.gif?alt=media&token=ae9287e5-4cb6-4579-9604-e7dbc4f2b6f6",
        },
        {
            name: "Deutsche",
            language: "german",
            img: "https://firebasestorage.googleapis.com/v0/b/hey-addy-chatgpt.appspot.com/o/public%2FlandingPage%2FmultilingualDemo%2Fmultilingual_german.gif?alt=media&token=c34375e0-d2fd-4ecf-a009-2f375e4b13e6",
        },
        {
            name: "Urdu",
            language: "urdu",
            img: "https://firebasestorage.googleapis.com/v0/b/hey-addy-chatgpt.appspot.com/o/public%2FlandingPage%2FmultilingualDemo%2Fmultilingual_urdu.gif?alt=media&token=0fb5ba3f-82aa-4920-810d-f6780b758902",
        },
        {
            name: "Japanese",
            language: "japanese",
            img: "https://firebasestorage.googleapis.com/v0/b/hey-addy-chatgpt.appspot.com/o/public%2FlandingPage%2FmultilingualDemo%2Fmultilingual_japanese.gif?alt=media&token=c7791daa-071a-41fa-8847-e3fb70d5039e",
        },
        {
            name: "Italian",
            language: "italian",
            img: "https://firebasestorage.googleapis.com/v0/b/hey-addy-chatgpt.appspot.com/o/public%2FlandingPage%2FmultilingualDemo%2Fmultilingual_italian.gif?alt=media&token=78dfc916-054c-4258-965f-e71775d667ed",
        },
        {
            name: "Korean",
            language: "korean",
            img: "https://firebasestorage.googleapis.com/v0/b/hey-addy-chatgpt.appspot.com/o/public%2FlandingPage%2FmultilingualDemo%2Fmultilingual_korean.gif?alt=media&token=ef824adf-a954-4f5b-99e0-97ff7f3c7d6b",
        },
        {
            name: "Hungarian",
            language: "hungarian",
            img: "https://firebasestorage.googleapis.com/v0/b/hey-addy-chatgpt.appspot.com/o/public%2FlandingPage%2FmultilingualDemo%2Fmultilingual_hungarian.gif?alt=media&token=23134fff-3bdc-40e1-8094-17669792a956",
        },
        {
            name: "Dutch",
            language: "hungarian",
            img: "https://firebasestorage.googleapis.com/v0/b/hey-addy-chatgpt.appspot.com/o/public%2FlandingPage%2FmultilingualDemo%2Fmultilingual_dutch.gif?alt=media&token=c7e12757-172f-4836-afea-fb788c5ea809",
        },

        /*... Add more languages here ...*/
    ];

    const handleQuestionClick = index => {
        setSelectedQuestion(index);
    };

    let newDemoImageWidth = styles.basic.demoImageWidth;
    newDemoImageWidth = styles.basic.smallScreen ? newDemoImageWidth : 0.85 * newDemoImageWidth;
    
    return (
        <div>
            <div md={8} className="answer-box">
                <div className="answer" style={{
                    display: styles.basic.smallScreen ? "flex" : "flex",
                }}>
                    <img src={languages[selectedQuestion].img}
                        style={{
                            width: newDemoImageWidth,
                        }}
                        className="DemoImage" />
                </div>
            </div>

            <div className="languages-list-div" style={{
                display: "flex",
                gap: 10,
                flexWrap: "wrap",
                width: newDemoImageWidth,
            }}>
                {languages.map((language, index) => (
                    <div
                        key={index}
                        className={`language-demo ${index === selectedQuestion ? "active" : ""}`}
                        onClick={() => handleQuestionClick(index)}>

                        {language.name}

                    </div>
                ))} <p className="language-more">+100 more</p>
            </div>
        </div>
    );
};

export default MultiLingualDemo;
